<template>
  <div>
    <CRow class="m-1">
      <CCol col="3">
        <date-picker
            :label="$t('components.startDate')"
            v-model="start_date"></date-picker>
      </CCol>
      <CCol col="3">
        <date-picker
            :label="$t('components.endDate')"
            v-model="end_date"></date-picker>

      </CCol>
      <CCol col="2">
        <CButton size="sm" @click="get_all_data()" color="secondary">
          {{$t('search')}}
        </CButton>
      </CCol>
      <CCol col="2">
        <CButton  @click="change_status_modal=true" type="submit" size="sm" color="secondary">
          {{$t('acceptExitProducts')}}
        </CButton>
      </CCol>

    </CRow>


    <CDataTableFixed
        :items="exit_delivery_product_inventory_items"
        :fields="exit_factors_inventory_fields"
        striped
        border
        column-filter
        :checkbox="true"
        :checkbox_ids.sync="selected_factors_for_status"
        checkbox_key="productId"
        sorter
        height="300px"
        :items-per-page="200"
        hover
        pagination
    >
<!--      <template #select-header="{item}">-->
<!--        <input type="checkbox" v-model="check_all_exit"-->
<!--        />-->
<!--      </template>-->
<!--      <template #select="{item}">-->
<!--        <td>-->
<!--          <input type="checkbox" ref="permissions[]" v-model="selected_factors_for_status"-->
<!--                 :value="item.productId"/>-->
<!--        </td>-->
<!--      </template>-->
      <template #qty="{item}">
        <td>
          <p style="text-align: right">{{get_currency_no_fix(Math.abs(item.qty))}}</p>
        </td>
      </template>
      <template #productCode="{item}">
        <td>
          <p style="text-align: center">{{item.productCode}}</p>
        </td>
      </template>
      <template #masterId="{item,index}">
        <td>
          <p style="text-align: center">{{index+1}}</p>
        </td>
      </template>

    </CDataTableFixed>

    <CModal
        :show.sync="change_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          {{$t('sureToConfirm')}}
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

var items = [];


export default {
  name: 'Login',
  components: {

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      start_date: '',
      end_date: '',
      change_status_modal: false,
      selected_factors_for_status: [],
      selected_status: 0,

       change_status_summary: '',

      exit_delivery_product_inventory_items: [],
      all_accounting_list:[],
      filtered_accounting_list:[],

      exit_factors_inventory_fields: [

        {key: 'masterId', label: this.$t('tables.number'), _style: 'width:2%'},
        // {key: 'انبار', _style: 'width:10%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},

        {key: 'productName', label: this.$t('components.productName'), _style: 'width:30%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        // {key: 'existance', label: this.$t('balanceQty'), _style: 'width:15%'},
        // {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},

        // {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

      ],


      status_form: 0,
      check_all_exit: false,

    }
  },
  mounted() {
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    bus.$on('platform_updated', (data) => {
      this.get_all_data()
    });

    this.get_all_data();


  }, watch: {
    'check_all_exit': function () {


      if (this.check_all_exit) {
        this.selected_factors_for_status = [];

        this.exit_delivery_product_inventory_items.forEach((val) => {
          this.selected_factors_for_status.push(val.productId);
        });
      } else {
        this.selected_factors_for_status = [];
      }
    },
    // 'start_date': function () {
    //   this.get_all_data();
    // },
    // 'end_date': function () {
    //   this.get_all_data();
    // },

  },
  methods: {

    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },
    change_status_data(index) {

      if(this.selected_factors_for_status.length==0){
        return false;

      }
      this.change_status_modal = false;
      var self = this;

      const formData = new FormData();

      formData.append('ProductId', this.selected_factors_for_status[index]);
      this.exit_delivery_product_inventory_items.filter(x=> x.productId==this.selected_factors_for_status[index])[0].masterIds.forEach(function (val){
        formData.append('Ids[]', val);

      })
      formData.append('FacStatus',2);

      axios.post('AddFactorPlatform', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if(index < self.selected_factors_for_status.length - 1 ){
            self.change_status_data(index+1);
          }else{
            self.selected_factors_for_status = []
            self.get_all_data();
          }


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },

    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_all_data(){
      this.get_insite_lists()
    },


    get_insite_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);

      self.selected_factors_for_status = []

      axios.post('GetFactorLoadingPlatforms', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          let grouping = []

          content_data.data.forEach(function (val){
            if(grouping.filter(x=>x.productId == val.productId).length>0){
              grouping.filter(x=>x.productId == val.productId)[0].qty += val.qty
              grouping.filter(x=>x.productId == val.productId)[0].masterIds.push(val.masterId)
            }else{
              val.masterIds = []
              val.masterIds.push(val.masterId)
              grouping.push(val)

            }
          })
          self.exit_delivery_product_inventory_items = grouping.map((item, row_id) => {
            return {...item, row_id}
          });

          // self.exit_delivery_product_inventory_items = content_data.data.map((item, row_id) => {
          //   return {...item, row_id}
          // });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },


  }
}

</script>
